<div class="form-group" *ngIf="showLinks">
  <label class="form-label">Zoho customer ID</label>
  <a
    *ngIf="settings?.zohoContactId"
    class="form-control text-primary"
    [href]="contactUrl(settings.zohoContactId)"
    target="_blank"
    rel="noopener noreferrer"
    >{{ settings.zohoContactId }}</a
  >
  <div *ngIf="!settings?.zohoContactId" class="form-control text-muted">Not linked</div>
</div>
<div class="form-group" *ngIf="showLinks && settings?.previousZohoContactIds?.length">
  <label class="form-label">Previous Zoho customer IDs</label>
  <div *ngFor="let id of settings.previousZohoContactIds">
    <a [href]="contactUrl(id)" target="_blank" rel="noopener noreferrer">{{ id }}</a>
    <button
      type="button"
      class="btn btn-link btn-sm text-danger"
      [disabled]="removing"
      (click)="removeLink(id)"
      [attr.aria-label]="'Remove previous Zoho customer link ' + id"
      title="Remove link from platform">
      <i class="fas fa-trash-alt" aria-hidden="true"></i>
    </button>
  </div>
  <div class="form-text">Handle payments for these customers manually in Zoho.</div>
</div>
<div class="alert alert-warning" role="alert" *ngIf="replacementRequired">
  Saving an approved company-name, country, or VAT-number change creates a new Zoho customer if an invoice exists in the platform or Zoho. If no
  invoice exists, the existing customer is updated. Previous invoices remain unchanged; handle their payments manually in Zoho.
</div>
